<script>
import { Pie } from "vue-chartjs";

export default {
    extends: Pie,
    props: ['chartdata', 'options', 'styles'],
    mounted() {
      if (this.styles) {
        Object.assign(this.$refs.canvas.style, this.styles);
      }
		  this.renderChart(this.chartdata, this.options);
    }
};
</script>